import Vue from "vue";
import VueRouter from "vue-router";
import common from "@/utils/common.js";
import store from "@/store/index";
import { host_51 } from "@/utils/constant";
import sensor from "@/utils/sensors";
import userAxios from "@/apis/user";
import jsBridge from "@51job/jbs-jsbridge";

import Activity from "@/views/Index.vue";
import AskQuestion from "@/views/AskQuestion.vue";
import QuestionDetail from "@/views/QuestionDetail.vue";
import QuestionAndAnswerList from "@/views/QuestionAndAnswerList.vue";
import DataCollectionPages from "@/views/DataCollectionPages.vue";
import Ai from "@/views/Ai.vue";
import CreaterHome from "@/views/CreaterHome.vue";

import ScanCode from "@/views/ScanCode.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/op/:pageId",
    name: "Activity",
    component: Activity,
    meta: {
      loginType: "",
    },
  },
  {
    path: "/askQuestion",
    name: "AskQuestion",
    component: AskQuestion,
    meta: {
      loginType: "1",
    },
  },
  {
    path: "/questionDetail",
    name: "QuestionDetail",
    component: QuestionDetail,
    meta: {
      loginType: "1",
    },
  },
  {
    path: "/questionAndAnswerList",
    name: "QuestionAndAnswerList",
    component: QuestionAndAnswerList,
    meta: {
      loginType: "1",
    },
  },
  {
    path: "/dataCollectionPages",
    name: "DataCollectionPages",
    component: DataCollectionPages,
    meta: {
      loginType: "1",
    },
  },
  {
    path: "/Ai",
    name: "Ai",
    component: Ai,
    meta: {
      loginType: "1",
    },
  },
  {
    path: "/Ai/:interviewId",
    name: "AiSub",
    component: Ai,
    meta: {
      loginType: "1",
    },
  },
  {
    path: "/scanCode",
    name: "ScanCode",
    component: ScanCode,
    meta: {
      loginType: "",
    },
  },
  {
    path: "/createrHome",
    name: "CreaterHome",
    component: CreaterHome,
    meta: {
      loginType: "1",
    },
  }
];

const router = new VueRouter({
  mode: "history",
  // base: "/",
  base: process.env.BASE_URL,
  routes,
});

const currentHref = window.location.href;
const from = currentHref.indexOf(host_51) > -1 ? "51job" : "yjs";
common.initDevice(from);

router.beforeEach(async (to, from, next) => {
  if (from.query.partner) {
    store.commit("setValueLocalStorage", {
      partner: from.query.partner,
      partnerH5: from.query.partner,
    });
  } else {
    if (localStorage.getItem("partner")) {
      store.commit("setValueLocalStorage", {
        partner: localStorage.getItem("partner"),
        partnerH5: localStorage.getItem("partner"),
      });
    } else store.commit("setValueLocalStorage", { partner: "", partnerH5: "" });
  }
  const { platform } = store.getters;
  console.log("platform:::", platform);
  console.log("appType:::", store.getters.appType);
  store.commit("setValue", {
    frompageUrl: `${window.location.origin}${from.fullPath}`,
    pageUrlInfo: to,
  });
  sensor.initSensors(store);

  common.shouldNativeBackGesture();
  //登录态 loginType 1必须登录  2必不登录  空：获取登录信息不强登
  if (
    to.meta.loginType == 2 ||
    (store.state.commonStore.accountId &&
      new Date(parseInt(store.state.commonStore.logintime)).toDateString() ===
        new Date().toDateString() &&
      ["51jobM", "51jobPC", "yjsM", "yjsPC"].includes(platform))
  ) {
    let dis = store.state.commonStore.accountId || store.state.commonStore.uuid;
    if (!dis) {
      store.commit("setValueLocalStorage", {
        identityType: "",
        userType: "",
      });
    }
    common.sensorsInit();
    next();
  } else {
    if (["51jobM", "51jobPC"].includes(platform)) {
      userAxios.getUserToken().then((res) => {
        const { accountId, token, uuid, userType, identityType, mobilephone } =
          res?.resultBody || {};
        if (res?.status == 1 && res?.resultBody.accountId) {
          store.commit("setValueLocalStorage", {
            identityType: identityType,
            userType: userType,
            accountId: accountId,
            token: token,
            uuid: uuid,
            mobilephone: mobilephone,
            logintime: new Date().getTime(),
          });
          common.sensorsInit(accountId, uuid);
          next();
        } else {
          const { uuid } = res?.resultBody || {};
          store.commit("setValueLocalStorage", {
            isGetUserToken: "0",
            accountId: "",
            token: "",
            identityType: "职场人",
            userType: "",
            userInfo: "",
            mobilephone: "",
            uuid: uuid,
          });
          common.sensorsInit();
          if (to.meta.loginType == 1) {
            common.toLogin(to.query.partner);
          } else {
            next();
          }
        }
      });
    } else if (["yjsM", "yjsPC"].includes(platform)) {
      userAxios.getYjsUsetToken().then((res) => {
        const { result, accountid, usertoken, uuid, createDate } =
          res?.resultBody || {};
        if (result == 1 && accountid) {
          store.commit("setValueLocalStorage", {
            accountId: accountid,
            token: usertoken,
            uuid: uuid,
            userType:
              new Date(createDate).toDateString() == new Date().toDateString()
                ? "新用户"
                : "老用户",
            // partner: partner,
            logintime: new Date().getTime(),
            identityType: "在校生",
          });
          common.sensorsInit(accountid, uuid);
          next();
        } else {
          store.commit("setValueLocalStorage", {
            isGetUserToken: "0",
            accountId: "",
            token: "",
            uuid: uuid,
            identityType: "在校生",
          });
          common.sensorsInit();
          if (to.meta.loginType == 1) {
            common.toLogin(to.query.partner);
          } else {
            next();
          }
        }
      });
    } else if (["yjsApp", "51jobApp"].includes(platform)) {
      jsBridge.getUserInfo().then((res) => {
        if (res) {
          console.log(res, 'getUserInfogetUserInfogetUserInfogetUserInfo')
          if (platform === "yjsApp") {
            const { uuid } = res;
            let accountid = "";
            let jwt = res["xy-jwt"];
            if (jwt && jwt.split(".")[1]) {
              let arr = window.atob(jwt.split(".")[1]);
              accountid = JSON.parse(arr).aud;
            }
            const params = {
              accountId: accountid,
              token: res["xy-user-token"],
              uuid: uuid,
              fromdomain: res["from-domain"],
              logintime: new Date().getTime(),
              identityType: "在校生",
            };
            store.commit("setValueLocalStorage", params);
            common.sensorsInit(accountid, uuid);
          } else {
            const { accountid, uuid, identityType } = res;
            store.commit("setValueLocalStorage", {
              accountId: accountid,
              token: res["cupid-user-token"],
              uuid: uuid,
              fromdomain: res["from-domain"],
              logintime: new Date().getTime(),
              identityType: identityType == "1" ? "职场人" : "在校生",
            });
            common.sensorsInit(accountid, uuid);
          }
        }
        next();
      });
    } else if (["yjsWX", "51jobWX"].includes(platform)) {
      const info = to.query.userinfo || localStorage.getItem("weixinUserInfo");
      let userInfo = info ? JSON.parse(info) : {};
      const { accountid, token, fromdomain, partner, uuid, identityType } =
        userInfo || {};
      const params = {
        identityType: identityType == "1" ? "职场人" : "在校生",
        accountId: accountid,
        token: token,
        uuid: uuid,
        fromdomain: fromdomain,
        partner: partner,
        partnerH5: from.query.partner,
        logintime: new Date().getTime(),
        weixinUserInfo: JSON.stringify(userInfo),
      };
      store.commit("setValueLocalStorage", params);
      common.sensorsInit(accountid, uuid);
      next();
    }
  }
});

router.afterEach(() => {
  // 当页面为打开的第一个页面时，url添加进sessionStorage
  if (!window.sessionStorage.firstUrl) {
    window.sessionStorage.firstUrl = window.location.href;
  }
});

export default router;

